import TableCell from "@mui/material/TableCell";
import React, { PropsWithChildren } from "react";
import type { ColumnDefinition } from "./QATable";
import { getPadding, PaddingObject } from "../../../util/StyleUtils";

interface Props<T> {
    testId?: string;
    config: ColumnDefinition<T>;
    defaultPadding?: PaddingObject;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const QATableCell: React.FC<PropsWithChildren<Props<any>>> = props => {
    return (
        <TableCell
            data-cy={props.testId}
            style={{
                height: "1px", // Allows having full height children
                width: props.config.width,
                maxWidth: props.config.noWrap ? props.config.width : undefined,
                whiteSpace: props.config.noWrap ? "nowrap" : undefined,
                textOverflow: props.config.noWrap ? "ellipsis" : undefined,
                overflow: props.config.noWrap ? "hidden" : undefined,
                padding: getPadding(props.config.padding, props.defaultPadding ?? { top: 12, right: 16, bottom: 12, left: 16 }),
            }}>
            {props.children}
        </TableCell>
    );
};

export default QATableCell;
